import Icon from '../components/Icon.vue'

Icon.register({
  tenge: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 160H12C5.4 160 0 165.4 0 172V228C0 234.6 5.4 240 12 240H152V468C152 474.6 157.4 480 164 480H220C226.6 480 232 474.6 232 468V240H372C378.6 240 384 234.6 384 228V172C384 165.4 378.6 160 372 160zM372 32H12C5.4 32 0 37.4 0 44V100C0 106.6 5.4 112 12 112H372C378.6 112 384 106.6 384 100V44C384 37.4 378.6 32 372 32z'
      }
    ]
  }
})
